<template>
  <div class="page_content share_social_pg">

    <div class="main_section">
      <div class="container">

        <div class="row justify-content-center top_title">
          <div class="col-12 text-center">
            <h1>Dank Voor Het Delen!</h1>

          </div>


          <div class="col-12">
            <div class="d-flex flex-column flex-md-row flex-lg-row justify-content-center align-items-center my-0 my-lg-5 my-md-5 social_confirm_parag">
              <p class="w-100 text-center">
                We hopen je weer snel terug te zien bij Prepaid Surprise. Je kunt zo vaak meespelen
                met Prepaid Surprise als je wilt. Elke keer dat je opwaardeert, ontvang je een
                speelcode. Met deze speelcode kun je het spel spelen. Je wint altijd gegarandeerd
                extra gratis MB's, belminuten of sms'jes, en misschien wel een hoofdprijs! Bij ons
                is iedereen een winnaar!
              </p>
            </div>
          </div>
        </div>


        <div class="row justify-content-center btn_content air_btn">
          <button v-if="this.getAccessToken && pendingCodes.length>0" type="button"
                  class="black_btn  mr-1"
                  @click.prevent="redirectCustomer(pendingCodes[pendingCodes.length==1?0:pendingCodes.length-1].code)">
            Speel opnieuw
          </button>
          <button type="button" class="black_secondary_btn ml-1" @click="this.isLoggedIn">
            Terug naar Prepaid Surprise
          </button>
        </div>

      </div>
    </div>


  </div>

</template>

<script>
import router from '../router'
import {mapActions, mapGetters, mapMutations} from 'vuex'
import gameFlow from '../common/mixin/gameFlow'

export default {
  name: "SocialConfirmation",
  data() {
    return {
      pendingCodes: [],
    }
  },
  computed: {
    ...mapGetters([
      'getLoginResponse',
      'getAccountResponse',
      'getGameFlowState',
    ]),
    console: () => console,
  },
  mixins: [
    gameFlow
  ],
  mounted() {
    // Method that when the page is loading will pull user's open codes
    this.loadMyAccount()
      .then(() => {
        this.pendingCodes = this.getAccountResponse.pendingCodes
      })
      .catch((error) => {
      this.pendingCodes = []
    })

    },
    // End Method
  methods: {
    ...mapMutations([
      'updateSelectedCodeForRedemption'
    ]),
    ...mapActions([
      'loadMyAccount',
      'redeemCode'

    ]),
    // Method that if the user is logged in will direct him to Account page, otherwise will redirect him to Home page
    isLoggedIn() {

      if (this.getAccessToken) {
        router.push({name: 'Account'})
      } else {
        router.push({name: 'Home'})
      }
    },
    // End Method
    // Method that takes the last open code of the customer and redirects him to gameOption.js in order to play that code
    redirectCustomer(code) {
      this.resetGameState()
      this.updateSelectedCodeForRedemption(code)
      this.redeemCode()
        .then((response) => {
          this.$store.commit('updateGameFlowState', response.data.currentConversationState)
          if (this.getGameFlowState)
            this.loadInfoFromConversation(response)
          this.gameRouting()
        })
    }
    // End Method
  }
}


</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/SocialConfirmation.vue